import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CalendarioPagoData } from '../../../shared/models';
import { CatalogosService } from '../../../shared/services/catalogos.service';

@Component({
  selector: 'app-formulario-calendario',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzDatePickerModule,
    NzSelectModule,
    NzTimePickerModule
  ],
  templateUrl: './formulario-calendario.component.html',
  styleUrl: './formulario-calendario.component.scss'
})
export class FormularioCalendarioComponent implements OnInit {
  calendarioForm!: FormGroup;
  Edicion = false;
  @Input() data: CalendarioPagoData | undefined;
  
  fechaMinima: Date | null = null;
  fechaMaxima: Date | null = null;

  meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  constructor(
    private fb: FormBuilder,
    private drawerRef: NzDrawerRef<FormularioCalendarioComponent>,
    private message: NzMessageService,
    private catalogosService: CatalogosService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.calendarioForm = this.fb.group({
      id: [this.data ? this.data.id : 0],
      mesContable: [ { value: this.data ? this.data.mesContable : null, disabled: false }, [Validators.required]],
      periodoInicio: [ { value: this.data ? this.parseLocalDate(this.data.periodoInicio) : null, disabled: true }, [Validators.required]],
      periodoFin: [ { value: this.data ? this.parseLocalDate(this.data.periodoFin) : null, disabled: true }, [Validators.required]],
      limiteInfoColaborador: [ { value: this.data ? this.parseLocalDateTime(this.data.limiteInfoColaborador) : null, disabled: true }, [Validators.required]],
      limiteInfoSap: [ { value: this.data ? this.parseLocalDateTime(this.data.limiteInfoSap) : null, disabled: true }, [Validators.required]]
    });
    if (this.data) {
      this.calendarioForm.enable();
      this.actualizarFechasAñoActual();
    }
    this.calendarioForm.get('mesContable')?.valueChanges.subscribe(value => {
      if (value) {
        const rango = this.obtenerRangoFechasPorMes(value);
        if (rango) {
          this.fechaMinima = rango.fechaInicio;
          this.fechaMaxima = rango.fechaLimite;
          
          this.calendarioForm.get('periodoInicio')?.setValue(rango.fechaInicio);
          this.calendarioForm.get('periodoFin')?.setValue(rango.fechaFin);
          this.calendarioForm.get('limiteInfoColaborador')?.setValue(rango.fechaLimite);
          this.calendarioForm.get('limiteInfoSap')?.setValue(rango.fechaLimite);

          this.calendarioForm.get('periodoInicio')?.enable();
          this.calendarioForm.get('periodoFin')?.enable();
          this.calendarioForm.get('limiteInfoColaborador')?.enable();
          this.calendarioForm.get('limiteInfoSap')?.enable();
        }
      } else {
        this.fechaMinima = null;
        this.fechaMaxima = null;
        
        this.calendarioForm.get('periodoInicio')?.setValue(null);
        this.calendarioForm.get('periodoFin')?.setValue(null);
        this.calendarioForm.get('limiteInfoColaborador')?.setValue(null);
        this.calendarioForm.get('limiteInfoSap')?.setValue(null);

        this.calendarioForm.get('periodoInicio')?.disable();
        this.calendarioForm.get('periodoFin')?.disable();
        this.calendarioForm.get('limiteInfoColaborador')?.disable();
        this.calendarioForm.get('limiteInfoSap')?.disable();
      }
    });
  }


  private obtenerRangoFechasPorMes(nombreMes: string, año?: number): { fechaInicio: Date, fechaFin: Date, fechaLimite: Date } | null {
    const añoActual = año || new Date().getFullYear();
    
    const indiceMes = this.meses.indexOf(nombreMes);
    
    if (indiceMes === -1) {
      console.error('Mes no válido:', nombreMes);
      return null;
    }
    
    const fechaInicio = new Date(añoActual, indiceMes, 1);
    
    const fechaFin = new Date(añoActual, indiceMes + 1, 0);
    const fechaLimite = new Date(añoActual, indiceMes + 1, 15);
    return {
      fechaInicio,
      fechaFin,
      fechaLimite
    };
  }

  private actualizarFechasAñoActual(): void {
    if (!this.data) return;
    const rango = this.obtenerRangoFechasPorMes(this.calendarioForm?.get('mesContable')?.value);
    if (rango) {
      this.fechaMinima = rango.fechaInicio;
      this.fechaMaxima = rango.fechaLimite;
    }
    
    const añoActual = new Date().getFullYear();

    if (this.data.periodoInicio) {
      const fechaInicio = this.parseLocalDate(this.data.periodoInicio);
      const fechaInicioActual = new Date(añoActual, fechaInicio!.getMonth(), fechaInicio!.getDate());
      this.calendarioForm.get('periodoInicio')?.setValue(fechaInicioActual);
      this.Edicion = (fechaInicio!.getTime() !== fechaInicioActual!.getTime());
    }

    if (this.data.periodoFin) {
      const fechaFin = this.parseLocalDate(this.data.periodoFin);
      const fechaFinActual = new Date(añoActual, fechaFin!.getMonth(), fechaFin!.getDate());
      this.calendarioForm.get('periodoFin')?.setValue(fechaFinActual);
      this.Edicion = this.Edicion || (fechaFin!.getTime() !== fechaFinActual!.getTime());
    }

    if (this.data.limiteInfoColaborador) {
      const fechaLimiteCol = this.parseLocalDateTime(this.data.limiteInfoColaborador);
      const fechaLimiteColActual = new Date(
        añoActual, 
        fechaLimiteCol!.getMonth(), 
        fechaLimiteCol!.getDate(),
        fechaLimiteCol!.getHours(),
        fechaLimiteCol!.getMinutes(),
        fechaLimiteCol!.getSeconds()
      );
      this.Edicion = this.Edicion || (fechaLimiteCol!.getTime() !== fechaLimiteColActual!.getTime());
      this.calendarioForm.get('limiteInfoColaborador')?.setValue(fechaLimiteColActual);
    }

    if (this.data.limiteInfoSap) {
      const fechaLimiteSap = this.parseLocalDateTime(this.data.limiteInfoSap);
      const fechaLimiteSapActual = new Date(
        añoActual,
        fechaLimiteSap!.getMonth(),
        fechaLimiteSap!.getDate(),
        fechaLimiteSap!.getHours(),
        fechaLimiteSap!.getMinutes(),
        fechaLimiteSap!.getSeconds()
      );
      this.calendarioForm.get('limiteInfoSap')?.setValue(fechaLimiteSapActual);
      this.Edicion = this.Edicion || (fechaLimiteSap!.getTime() !== fechaLimiteSapActual!.getTime());
    }
  }

  disabledDate = (current: Date): boolean => {
    if (!this.fechaMinima || !this.fechaMaxima) {
      return false;
    }
    
    return current < this.fechaMinima || current > this.fechaMaxima;
  };

  onSubmit(): void {
    if (!this.calendarioForm.valid) {
      this.markAllFieldsAsTouched();
      this.message.error('Por favor, completa todos los campos requeridos');
      return;
    }

    let data = this.calendarioForm.getRawValue();
    data.periodoInicio = this.formatDateToString(data.periodoInicio);
    data.periodoFin = this.formatDateToString(data.periodoFin);
    data.limiteInfoColaborador = this.formatDateTimeToString(data.limiteInfoColaborador);
    data.limiteInfoSap = this.formatDateTimeToString(data.limiteInfoSap);
        
    if( this.data ) {
      this.catalogosService.actualizarCalendario(data).subscribe({
        next: (res) => {
          this.message.success('Calendario actualizado correctamente');
          this.drawerRef.close(true);
        },
        error: (err) => {
          this.message.error('Error al actualizar el calendario');
        }
      });
    }
    else {
      this.catalogosService.addCalendario(data).subscribe({
        next: (res) => {
          this.message.success('Calendario agregado correctamente');
          this.drawerRef.close(true);
        },
        error: (err) => {
          this.message.error('Error al agregar el calendario');
        }
      });
    }
  }
  
  private markAllFieldsAsTouched(): void {
    Object.keys(this.calendarioForm.controls).forEach(key => {
      this.calendarioForm.get(key)?.markAsTouched();
    });
  }

  private parseLocalDate(dateString: Date | string): Date | null {
    if (!dateString) return null;
    
    if (dateString instanceof Date) return dateString;
    
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateString)) {
      const parts = dateString.split('T')[0].split('-');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
      
      return new Date(year, month, day);
    }
    
    return new Date(dateString);
  }

  private parseLocalDateTime(dateString: Date | string): Date | null {
    if (!dateString) return null;
    
    if (dateString instanceof Date) return dateString;
    
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateString)) {
      const [datePart, timePart] = dateString.split('T');
      const [year, month, day] = datePart.split('-').map(n => parseInt(n, 10));
      const [hour, minute, second] = timePart.split(':').map(n => parseInt(n, 10));
      
      return new Date(year, month - 1, day, hour, minute, second);
    }
    
    return new Date(dateString);
  }

  private formatDateToString(date: Date): string {
    if (!date || !(date instanceof Date)) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  private formatDateTimeToString(date: Date): string {
    if (!date || !(date instanceof Date)) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  get isFormValid(): boolean {
    return this.calendarioForm.valid;
  }
}
